
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, getFirestore, setDoc, updateDoc } from 'firebase/firestore';
import { conditionUnitConverter, CONDITION_UNIT } from '../entities/ConditionUnit';
import { SHOP } from '../entities/Shop';
import firebase from '../firebase/Firebase';

const store = getFirestore(firebase);

export const generateConditionUnitId = (shopId) => {
  if (!shopId) return
  const shopRef = doc(store, SHOP, shopId)
  const unitCollection = collection(shopRef, CONDITION_UNIT)
  return doc(unitCollection).id
}

export const getConditionUnit = async (shopId: string, conditionUnitId: string) => {
  const shopRef = doc(store, SHOP, shopId)
  const conditionUnitRef = doc(shopRef, CONDITION_UNIT, conditionUnitId).withConverter(conditionUnitConverter);
  return await getDoc(conditionUnitRef).then((doc) => {
    return doc.data()
  }).catch((error) => {
    console.warn(error);
    return null
  });
};

export const getConditionUnits = async (shopId: string) => {
  if (!shopId) return

  const shopRef = doc(store, SHOP, shopId)
  const conditionUnitsRef = collection(shopRef, CONDITION_UNIT).withConverter(conditionUnitConverter);
  return await getDocs(conditionUnitsRef).then((snap) => {
    return snap.docs.map((doc) => doc.data())
  }).catch((error) => {
    console.warn(error);
    return null
  });
};

export const addConditionUnit = async (shopId: string, conditionUnit) => {
  const shopRef = doc(store, SHOP, shopId);
  return addDoc(
      collection(shopRef, CONDITION_UNIT).withConverter(conditionUnitConverter), conditionUnit
    ).then((ref) => {
      return ref.id;
    }).catch((err) => {
      console.warn(err);
      return null
    });
}

export const setConditionUnit = async (shopId: string, conditionUnit) => {
  const shopRef = doc(store, SHOP, shopId);
  return setDoc(
    doc(collection(shopRef, CONDITION_UNIT), conditionUnit.id).withConverter(conditionUnitConverter), conditionUnit
  ).catch((err) => {
    console.warn(err);
    return null
  });
}

export const updateConditionUnit = async (shopId: string, conditionUnit) => {
  const shopRef = doc(store, SHOP, shopId);
  return updateDoc(
    doc(collection(shopRef, CONDITION_UNIT), conditionUnit.id).withConverter(conditionUnitConverter), conditionUnit
  ).catch((err) => {
    console.warn(err);
    return null
  });
}

export const deleteConditionUnit = async (shopId: string, conditionUnit) => {
  const shopRef = doc(store, SHOP, shopId);
  return deleteDoc(
    doc(collection(shopRef, CONDITION_UNIT), conditionUnit.id)
  ).catch((err) => {
    console.warn(err);
    return null
  });
}